const config = [
  //   {
  //     component: 'ZlmTitle',
  //     options: {
  //       size: 'medium',
  //       text: '项目基本情况'
  //     }
  //   }
  //   {
  //     component: 'ZlmNormalDetail',
  //     options: {
  //       data: {},
  //     },
  //   },
]

const { getProjectTypeName } = require('../projectType')
const { getPurchaseTypeName } = require('../purchaseType')

const mixin = {
  data() {
    return {
      config: JSON.parse(JSON.stringify(config)),
    }
  },
  methods: {
    getData() {
      this.$request
        .post(
          '/transformToAfter/app/home/hxrgsDetail',
          {
            guid: this.$route.query.id,
            bdGuid: this.$route.query.bdGuid,
          },
          { showLoading: true },
        )
        .then((result) => {
          if (result.data?.length) {
            result.data.forEach((res, iindex) => {
              // 最后一条数据是初始公告，倒数第二条开始就是第一次变更以此类推
              this.config.push(
                ...[
                  {
                    component: 'ZlmTitle',
                    options: {
                      size: 'medium',
                      text:
                        result.data.length - iindex === 1
                          ? '初始公告'
                          : `第${result.data.length - iindex - 1}次变更`,
                    },
                  },
                  {
                    component: 'ZlmTitle',
                    options: {
                      size: 'medium',
                      text: '项目基本情况',
                    },
                  },
                  {
                    component: 'ZlmNormalDetail',
                    options: {
                      data: res.gcbd.gc.xiangmuXingzhi === 3 ? {
                        '标段/包名称': res.gcbd.bdName,
                        '标段/包编号': res.gcbd.bdBH,
                        项目类型: getProjectTypeName(res.gcbd.gc.xmLeiXing),
                        采购方式: getPurchaseTypeName(res.gcbd.gc.zbFangShi),
                        行业分类: res.hangYe,
                        经营资产交易类型: res.gcbd.gc.jyzcTransType === 1 ? '资产处置' : '租赁',
                      } : {
                        '标段/包名称': res.gcbd.bdName,
                        '标段/包编号': res.gcbd.bdBH,
                        项目类型: getProjectTypeName(res.gcbd.gc.xmLeiXing),
                        采购方式: getPurchaseTypeName(res.gcbd.gc.zbFangShi),
                        行业分类: res.hangYe,
                      },
                    },
                  },
                ],
              )
              this.config.push({
                component: 'ZlmNormalDetail',
                options: {
                  data: res.gcbd.gc.xiangmuXingzhi === 3 ? {
                    '标段/包名称': res.gcbd.bdName,
                    '标段/包编号': res.gcbd.bdBH,
                    项目类型: getProjectTypeName(res.gcbd.gc.xmLeiXing),
                    采购方式: getPurchaseTypeName(res.gcbd.gc.zbFangShi),
                    行业分类: res.hangYe,
                    经营资产交易类型: res.gcbd.gc.jyzcTransType === 1 ? '资产处置' : '租赁',
                  } : {
                    '标段/包名称': res.gcbd.bdName,
                    '标段/包编号': res.gcbd.bdBH,
                    项目类型: getProjectTypeName(res.gcbd.gc.xmLeiXing),
                    采购方式: getPurchaseTypeName(res.gcbd.gc.zbFangShi),
                    行业分类: res.hangYe,
                  },
                },
              })
              res.jglist.forEach((item, index) => {
                const quoteWay = res.gcbd.gc.quoteWay
                const data = {}
                data['中标候选人名称'] = item.tbrName
                if (quoteWay === 0) {
                  data['投标报价(元)'] = item.zhongBiaoJia
                } else if (quoteWay === 1) {
                  data['投标费率'] = item.zhongBiaoRate
                }
                data['质量'] = item.wjzhiLiang
                data['工期(交货期)'] = item.wjgongQi
                data['项目负责人'] = item.fuZeRen
                this.config.push(
                  ...[
                    {
                      component: 'ZlmTitle',
                      options: {
                        size: 'medium',
                        text: `第${index + 1}中标候选人`,
                      },
                    },
                    {
                      component: 'ZlmNormalDetail',
                      options: {
                        title: '变更',
                        data: data,
                      },
                    },
                  ],
                )
              })
            })
          }
        })
    },
  },
}

module.exports = {
  config,
  mixin,
}
